import { Component, Vue, Mixins, Prop, Emit } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from "@/util/SBAPI";
import { SBMailAuthenticationResponse } from '@/components/SBMailAuthentication';
import { EmailPass } from '@/generated/api';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import SBText from '@/components/SBText.vue';
import SBNextBack from '@/components/SBNextBack.vue';
import SBButtonSmall from '@/components/SBButtonSmall.vue';
import SBButtonSmallGray from '@/components/SBButtonSmallGray.vue';
import SBSignUpForm from '@/components/SBSignUpForm.vue';
import SBTextbox from '@/components/SBTextbox.vue';
import SBMailAuthentication from '@/components/SBMailAuthentication.vue';
import SBSubTitle from '@/components/SBSubTitle.vue';
import SBSection from '@/components/SBSection.vue';
import SBKurukuru from '@/components/SBKurukuru.vue';

@Component({
    components: {
        SBText,
        SBNextBack,
        SBButtonSmall,
        SBButtonSmallGray,
        SBSignUpForm,
        SBTextbox,
        SBMailAuthentication,
        SBSubTitle,
        SBSection,
        SBKurukuru,
    },
})
export default class PassRemind extends Mixins(CommonView) {
    mode: number = 0;

    emailPass: EmailPass = {
        code: "",
        email: "",
        pass: ""
    };

    @Prop({
        type: Object,
        default: null,
    })
    newUserToReminder!: SBMailAuthenticationResponse | null;

    passConfirmation: string = "";
    error: string = "";
    kurukuru: boolean = false;
    element: HTMLElement = <HTMLElement>document.scrollingElement;

    @Emit("signup")
    public signup(val: SBMailAuthenticationResponse) {
        return val;
    }

    public async created() {
        if (this.newUserToReminder) {
            this.emailPass.email = this.newUserToReminder.email;
            this.emailPass.code = this.newUserToReminder.code;
            this.mode = 1;
        }
    }

    public check1(val: SBMailAuthenticationResponse) {
        if (!val.user) {
            this.signup(val);
            return;
        }
        this.emailPass.email = val.email;
        this.emailPass.code = val.code;
        this.element.scrollTop = 0;
        this.mode = 1;
    }

    public async check2() {
        this.kurukuru = true;

        if (this.emailPass.pass != this.passConfirmation) {
            this.kurukuru = false;
            this.error = "パスワードが一致しません。";
            this.element.scrollTop = 0;
            return;
        }

        let res = await SBAPI.UserController.putLoginPassUsingPUT(this.emailPass).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
        } else {
            this.getUserAPI();
            this.mode = 2;
        }
        this.element.scrollTop = 0;
        this.kurukuru = false;
    }

    public back(value: number) {
        this.mode = value;
        this.element.scrollTop = 0;
    }

    public backRedirect() {
        this.$router.push("/");
    }
}

